import { render, staticRenderFns } from "./ProjectVideo.vue?vue&type=template&id=1cd449a8&scoped=true&"
import script from "./ProjectVideo.vue?vue&type=script&lang=js&"
export * from "./ProjectVideo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVideo.vue?vue&type=style&index=0&id=1cd449a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd449a8",
  null
  
)

export default component.exports